export default "__VITE_ASSET__BJ5tbdp9__"